import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { AppConfig, JWT } from '../../config';
import axios from 'axios';
import { SiteAction, AlertAction } from '../../actions';
import { history } from '../../history';
import { Translate as t } from '../../config/Translate';
import { Loading } from '../../components/common/Loading';
import { interpolate } from '../../config/i18nInterpolate';

const AdminSiteDelete = ({ site, isUpdateRes, DeleteSite, ClearUpdateResult }) => {

    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [errors, setErrors] = useState([]);
    const [delCheckResult, setDelCheckResult] = useState({ products: [] });
    const [checkError, setCheckError] = useState(false);

    useEffect(() => {
        setIsLoading(true)
        if (site._id) {
            axios.get(AppConfig.API_SERVER_PATH + '/site/getdelcheckinfo/' + site._id, JWT())
                .then((ret) => {
                    if (ret.data.status === "success") {
                        setDelCheckResult({ products: Array.isArray(ret.data.data) ? ret.data.data : [] });
                    } else {
                        setCheckError(true);
                        console.warn('[AdminSiteDelete] getdelcheckinfo non-success', { handler: 'AdminSiteDelete.useEffect', target: site._id, reason: ret.data?.err?.message || ret.data?.errmsg || 'non-success' });
                    }
                })
                .catch((err) => {
                    setCheckError(true);
                    console.warn('[AdminSiteDelete] getdelcheckinfo failed', { handler: 'AdminSiteDelete.useEffect', target: site._id, reason: err?.message || String(err) });
                })
                .finally(() => setIsLoading(false)); // BUG-156
        } else {
            setIsLoading(false); // BUG-156: fetch 없음 → 즉시 해제
        }
    }, []);

    useEffect(() => {
        if (isUpdateRes) {
            ClearUpdateResult();
            // U-26: 삭제 후 목록으로 이동 ('Deleted!' 안내는 SiteAction.DeleteSite 가 이미 띄움)
            history.push('/Admin/AdminSiteList');
        }
    }, [isUpdateRes]);

    const handleDeleteSite = (e) => {
        DeleteSite(site._id);
    }

    return (
        <div className="section">
            {isLoading && <Loading inline text={t('common.status.loading')} />}
            {!isLoading && checkError && (
                <div className="card bg-warning text-white">
                    <div className="card-header">
                        <div className="card-title">{t('common.label.warning')}</div>
                    </div>
                    <div className="card-body">
                        <h4>{t('common.message.delete.checkFailed')}</h4>
                        <p>{t('common.message.delete.checkFailedHint')}</p>
                    </div>
                </div>
            )}
            {!isLoading && !checkError &&
                <>
                    {delCheckResult.products.length > 0 && (
                        <>
                            <div className="card bg-danger text-white m-b-0">
                                <div className="card-header">
                                    <div className="card-title">{t('common.label.warning')}</div>
                                </div>
                                <div className="card-body">
                                    <h4>{interpolate(t('common.message.delete.cannotDelete'), { name: site.sitename })}</h4>
                                </div>
                            </div>
                            <ul className="list-group">
                                {delCheckResult.products.map(x => {
                                    return <li className="list-group-item"> <Link to={"/Admin/AdminProductInfo/" + x._id}>{x.sn}({x.model})</Link>{t('site.delete.installedProductSuffix')}</li>
                                })}
                            </ul>
                        </>
                    )}
                    {delCheckResult.products.length == 0 && (
                        <>
                            <div className="card bg-danger text-white">
                                <div className="card-header">
                                    <div className="card-title">{t('common.label.warning')}</div>
                                </div>
                                <div className="card-body">
                                    <h4>{t('common.message.delete.appliedImmediately')}</h4>
                                    <p>{t('common.message.delete.irreversible')}</p>
                                    <p>{t('common.message.confirm.delete')}</p>
                                </div>
                            </div>
                            <button className="btn btn-outline-danger" onClick={handleDeleteSite}>{t('site.button.deleteSite')}</button>
                        </>
                    )}
                </>
            }
        </div>
    );
};

const mapState = (state) => {
    const isUpdateRes = state.SiteReducer.isUpdateRes;
    return { isUpdateRes };
}

const mapDispatch = dispatch => ({
    ClearUpdateResult: () => dispatch(SiteAction.ClearUpdateResult()),
    DeleteSite: (siteid) => dispatch(SiteAction.DeleteSite(siteid))
})

export default connect(mapState, mapDispatch)(AdminSiteDelete);